// src/components/base/Chip/Chip.tsx
import type { ComponentChildren, ComponentProps } from 'preact';
import styles from './Chip.module.css';

export type ChipProps = Omit<ComponentProps<'div'>, 'children'> & {
  className?: string;
  children: ComponentChildren;
  icon?: ComponentChildren;
};

export function Chip({ className = '', children, icon, ...props }: ChipProps) {
  const rootClassName = [styles.chipRoot, className].filter(Boolean).join(' ');

  return (
    <div className={rootClassName} {...props}>
      {icon ? <span className={styles.icon}>{icon}</span> : null}
      <span className={styles.label}>{children}</span>
    </div>
  );
}
